import { useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from '@store';
import { SecurityLogs, PermissionEnum, PermissionDenied } from '@ui/src';
import {
  schema,
  columns,
  columnsLabels,
  filtersSchema,
} from '../variables/logs';
import useLogsList from '../hooks/use-logs-list';

import cn from '../styles.module.css';

const IndividualCustomerSecurityLogs = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const { baseInformation } = useAppSelector(
    (state) => state.individualCustomers.info.general,
  );
  const { logs, logsPagination, logsTakeCount } = useAppSelector(
    (state) => state.individualCustomers.info.security,
  );
  const { activePermissions } = useAppSelector((state) => state.root);

  const { getList, isLoading, isFetching } = useLogsList({ scrollRef });

  let content;

  if (!activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST)) {
    content = <PermissionDenied />;
  } else {
    content = (
      <>
        <SecurityLogs
          logs={logs}
          pagination={logsPagination}
          takeCount={logsTakeCount}
          activePermissions={activePermissions}
          schema={schema}
          getList={getList}
          isLoading={isLoading}
          filtersSchema={filtersSchema}
          columns={columns}
          columnsLabels={columnsLabels}
          isFetching={isFetching}
          tableTopClassName={cn.securityTableTop}
          userId={baseInformation?.userId}
        />
        <Outlet />
      </>
    );
  }

  return (
    <div className={cn.securityLocksContent} ref={scrollRef}>
      {content}
    </div>
  );
};

export default IndividualCustomerSecurityLogs;
